import { Components, Theme } from "@mui/material";

export const MuiAutocomplete: Components<
  Omit<Theme, "MuiAutocomplete">
>["MuiAutocomplete"] = {
  styleOverrides: {
    root: {
      "& .MuiOutlinedInput-root": {
        padding: "0px 12px",
      },

      // Empty state (label not shrunk): symmetric padding → centered placeholder
      "& .MuiOutlinedInput-input": {
        padding: "16px 0px",
      },
      "& .MuiInputAdornment-root": {
        alignSelf: "flex-start",
        marginTop: 16,
      },

      "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
        padding: "16px 4px 16px 5px",
      },

      // Has value / focused (label shrunk): asymmetric padding → gap between label and value
      "&:has(.MuiInputLabel-shrink) .MuiOutlinedInput-input": {
        paddingTop: 24,
        paddingBottom: 8,
      },
      "&:has(.MuiInputLabel-shrink) .MuiInputAdornment-root": {
        marginTop: 24,
      },
    },
    inputRoot: {
      display: "flex",
      alignItems: "center",

      // Override MUI Autocomplete's built-in padding for filled variant
      // so it matches regular FilledInput (see MuiFilledInput.ts)
      "&.MuiFilledInput-root": {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
      },
      "&.MuiFilledInput-root .MuiAutocomplete-input": {
        padding: "2px 16px",
      },
    },
  },
};
